import { getStartEndTimeFromAudioSummaryMetadata } from '@modules/feedback/components/AudioType/utils';
import { SummaryMessageUnit } from 'generated/graphql';
import { AudioConversationMessage } from 'v2/core/entities/feedback/content';
import { ReasonLabel } from 'v2/core/entities/feedback/labels';

export const getReasonSummaryUnits = (
  reasonLabel: ReasonLabel,
  keywordSummaryMap: Map<string, SummaryMessageUnit[]>,
  audioConversation: AudioConversationMessage[] | undefined,
) => {
  if (!reasonLabel.reasonUnits?.length || !keywordSummaryMap.size) {
    return [];
  }

  const summaryUnits = reasonLabel.reasonUnits?.reduce(
    (result: { unit: SummaryMessageUnit; startTime: number }[], reason) => {
      if (reason.type !== 'KEYWORD_SUMMARY') {
        return result;
      }

      const summaryUnit = keywordSummaryMap.get(reason.keywordSummaryLabelID)?.[
        reason.msgIDx
      ];
      const { startTime } = getStartEndTimeFromAudioSummaryMetadata(
        summaryUnit?.metadata,
        audioConversation ?? [],
      );

      if (summaryUnit) {
        return [
          ...result,
          {
            unit: summaryUnit,
            startTime,
          },
        ];
      }
      return result;
    },
    [],
  );

  const filteredReasonSummaryUnits = summaryUnits.filter(
    (summaryUnit, index) => {
      const isDuplicate =
        summaryUnits.findIndex((u) => u.unit.text === summaryUnit.unit.text) !==
        index;
      return !isDuplicate;
    },
  );

  return filteredReasonSummaryUnits
    .sort((a, b) => a.startTime - b.startTime)
    .map((summaryUnit) => summaryUnit.unit);
};
